'use client'

import LoginForm from '@/components/forms/login-form'
import RegisterForm from '@/components/forms/register-form'
import ThirdPartyLogin from '@/components/forms/third-party-login'
import { ConfigProvider } from 'antd'
import Cookies from 'js-cookie'
import { useTranslations } from 'next-intl'
import { useSearchParams } from 'next/navigation'
import React, { useEffect, useState } from 'react'

const Mode = {
  Login: 'login',
  Register: 'register',
}

const ValidModes = Object.values(Mode)

const theme = {
  components: {
    Checkbox: {
      controlInteractiveSize: 20,
    },
  },
}

export default function Page() {
  const t = useTranslations()
  const searchParams = useSearchParams()
  const defaultMode = ValidModes.includes(searchParams.get('mode'))
    ? searchParams.get('mode')
    : Mode.Login
  const redirectUrl = searchParams.get('from')
  const [mode, setMode] = useState(defaultMode)

  useEffect(() => {
    if (redirectUrl) {
      Cookies.set('from', redirectUrl)
    }
  }, [redirectUrl])

  const onSwitchMode = () => {
    setMode(mode === Mode.Login ? Mode.Register : Mode.Login)
  }

  return (
    <div>
      <div className='text-[#F9F9F9]'>
        <h2 className='mb-3 text-3xl font-semibold'>
          {t(`page.${mode}.title`)}
        </h2>
        <h3 className='text-sm font-normal'>{t(`page.${mode}.subtitle`)}</h3>
      </div>
      <ConfigProvider theme={theme}>
        <div className='my-[30px]'>
          {mode === Mode.Login ? <LoginForm /> : <RegisterForm />}
        </div>
      </ConfigProvider>
      <div className='flex items-center gap-x-6'>
        <hr className='flex-1 border-[#EDF2F7]' />
        <span className='text-xs font-medium text-[#718096]'>或</span>
        <hr className='flex-1 border-[#EDF2F7]' />
      </div>
      <div className='mb-5 mt-6'>
        <ThirdPartyLogin />
      </div>
      <p className='text-center text-sm font-semibold text-[#A9A9A9]'>
        {t(`page.${mode}.description`)}
        <span
          className='ml-1 cursor-pointer text-[#FF3C8E]'
          onClick={onSwitchMode}
        >
          {t(`page.${mode}.link`)}
        </span>
      </p>
    </div>
  )
}
